import React from "react";
import { CV } from "../components/cv";
import ThomasBImg from "@/assets/images/thomas-b.png";

export default function CVThomasBergstrom() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Thomas Bergström";
  }, []);

  return (
    <CV
      name="Thomas Bergström"
      title="Senior Interim Manager · Project/Program Manager"
      subtitle="25+ years driving e-commerce, IoT and digital transformation programs — engagements with HAKI Safety and SweIoT"
      photo={ThomasBImg}
      summary="Senior interim manager and project/program leader with 25+ years across ecommerce, digital transformation, and complex IT deliveries. Combines executive PMO background and hands-on software experience to drive structure, clarity, and business value for global enterprises and scale-ups. Known for translating business goals into actionable delivery plans and coaching teams through change."
      skills={{
        "Management": ["Project & Program Management", "Portfolio & Delivery Management", "PMO Setup", "Global Delivery Management"],
        "Leadership": ["Leadership & Coaching", "Stakeholder Management", "Contracting & Negotiations"],
        "Domains": ["Digital Transformation", "Ecommerce B2B/B2C", "Product Management", "IoT", "AI"],
        "Frameworks": ["PMI/PMP", "PROPS/XLPM", "PRINCE2", "Agile Ways of Working"],
        "Tools": ["Atlassian JIRA/Confluence", "Office 365", "Odoo ERP", "Salesforce CRM"],
        "Development": ["C/C++", "Java"],
      }}
      experience={[
        {
          role: "Interim Manager / Senior Project Manager",
          company: "UTB Consulting AB (owner)",
          period: "Aug 2021 – Present",
          description:
            "Owner delivering interim leadership and senior program/project management within IT, ecommerce, and digital transformation.",
        },
        {
          role: "Senior Project Manager / Interim Ecommerce Manager",
          company: "HAKI Safety AB (subcontractor)",
          period: "Jan 2022 – Present",
          description:
            "Lead delivery across multiple ecommerce and product initiatives for B2B/B2C markets, combining operational leadership with agile coaching.",
          highlights: [
            "Project manager and agile coach for Lasco 3D scaffolding visualization tool (2024–present)",
            "Responsible for development and launch of French ecommerce site (Jan–Jun 2025)",
            "Interim ecommerce manager overseeing operations (Nov 2024–May 2025)",
            "Led UK ecommerce/B2B/B2C launch (Feb–Aug 2024)",
            "Managed HAKI Group ecommerce implementation with Litium, Svea Checkout, nShift, Lime CRM, AX 2009 (2022)",
          ],
        },
        {
          role: "Interim CEO / Board Member",
          company: "SweIoT AB",
          period: "Jan 2024 – Jun 2025",
          description:
            "Interim CEO and board member for radar-based IoT sensor company serving industrial, infrastructure, and smart city applications.",
        },
        {
          role: "Management Consultant / Interim Client Director",
          company: "Impact Commerce AB (subcontractor)",
          period: "Jan – May 2024",
          description:
            "Strengthened PMO, operational efficiency, and client leadership for a major Swedish/Norwegian retail customer.",
        },
        {
          role: "COO / Senior Project Manager",
          company: "miThings AB (subcontractor, co-owner)",
          period: "Aug 2021 – Present",
          description:
            "Organizational and business development for IoT/eHealth startup; supported subsidiary SweIoT with IT infrastructure, supply chain, and scaling.",
        },
        {
          role: "VP Delivery & Client Success / VP Global Delivery / Project Manager",
          company: "Avensia AB",
          period: "2013 – 2021",
          description:
            "Progressed from project manager to executive leadership, owning global ecommerce and PIM project portfolios, governance, and client growth.",
          highlights: [
            "Led client directors and PMO directors; coached teams and supported sales",
            "Oversaw global delivery, contracts, bids, and portfolio governance",
            "Delivered ecommerce projects for Apotek Hjärtat and Ahlsell",
          ],
        },
        {
          role: "Director PMO, Professional Services & Customer Support",
          company: "Scalado AB",
          period: "2008 – 2013",
          description:
            "Owned global project portfolio, customer support, and internal processes; led teams across Sweden, US, Korea, and Taiwan.",
          highlights: ["Built teams by recruiting 30+ engineers and project managers", "Served on executive management team"],
        },
        {
          role: "Senior Software Project Manager",
          company: "Sony Ericsson Mobile Communications AB",
          period: "2007 – 2008",
          description:
            "Managed software quality, releases, and cross-site coordination for handsets including the C902 Alona.",
        },
        {
          role: "Senior Project/Program Manager",
          company: "Teleca Mobile AB",
          period: "2002 – 2007",
          description:
            "Led large-scale mobile software programs in Japan and the UK and contributed to Teleca's global PM model.",
          highlights: [
            "Managed Toshiba program with 250+ FTE",
            "Led Microsoft engagement with 100+ FTE",
          ],
        },
        {
          role: "Project Manager / Senior System Architect",
          company: "Aspiro AB",
          period: "2000 – 2002",
          description:
            "Architected and developed the Aspiro Mobile Application Platform used by 25+ operators globally.",
        },
        {
          role: "Software Engineer / Team Lead",
          company: "ABB Automation Products / Alfa Laval Automation / SattControl",
          period: "1995 – 2000",
          description:
            "Developed industrial control systems in C/C++ and Pascal; led teams building next-generation control platforms.",
        },
      ]}
      education={[
        {
          degree: "Certified Board Member",
          institution: "Styrelseakademien",
          year: "2023",
        },
        {
          degree: "PRINCE2 Foundation",
          institution: "APMG International",
          year: "2014",
        },
        {
          degree: "Project Management Professional (PMP)",
          institution: "Project Management Institute",
          year: "2013 (expired 2019)",
        },
        {
          degree: "Master of Science in Electric Engineering",
          institution: "Lund University (LTH)",
          year: "1990 – 1994",
        },
        {
          degree: "Natural Science",
          institution: "Malmö Latinskola",
          year: "1985 – 1988",
        },
      ]}
    />
  );
}
